<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="740px"
    :before-close="handleClose"
    :modal="true"
    :close-on-click-modal="false"
  >
    <div class="container-dialog">
      <el-form :model="formInline" ref="form" label-width="160px">
        <el-form-item label="所属模块">
          <el-input
            style="width: 356px;"
            v-model="formInline.extendClient"
            disabled
            placeholder="所属模块"
          ></el-input>
        </el-form-item>
        <el-form-item label="值守名称">
          <el-input
            style="width: 356px;"
            v-model="formInline.sxmc"
            placeholder="值守名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用">
          <el-switch
            v-model="formInline.state"
            active-value="是"
            inactive-value="否"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="打卡模式">
          <el-radio-group
            aria-hidden
            v-model="formInline.extendCardCount"
            key="1"
          >
            <el-radio label="1">单次打卡</el-radio>
            <el-radio label="2">双次打卡</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打卡时间">
          <el-radio-group aria-hidden v-model="dksj" key="2">
            <el-radio :label="1">限制打卡时间</el-radio>
            <el-radio :label="2">不限制</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="打卡时间" v-if="dksj == '1'">
          <div
            style="margin-bottom: 10px;display: flex;align-items: center;"
            v-for="(item, index) in formInline.extendTimeRangeList"
            :key="index"
          >
            <div style="display: flex;width: 80%;">
              <el-time-picker
                v-model="item.time1"
                style="width: 50% !important;"
                placeholder="选择时间"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              >
              </el-time-picker
              >至<el-time-picker
                style="width: 50% !important;"
                v-model="item.time2"
                placeholder="选择时间"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
              >
              </el-time-picker>
            </div>
            <i
              v-if="
                formInline.extendTimeRangeList.length === 1 ||
                  formInline.extendTimeRangeList.length - 2 === index
              "
              class="el-icon-plus"
              style="cursor: pointer;margin-left: 15px;font-size: 24px;"
              @click="pushFixedTimes"
            ></i>
            <i
              class="el-icon-minus"
              v-if="
                formInline.extendTimeRangeList.length > 1 &&
                  formInline.extendTimeRangeList.length - 1 === index
              "
              style="cursor: pointer;margin-left: 15px;font-size: 24px;"
              @click="minusFixedTimes(index)"
            ></i>
          </div>
        </el-form-item>
        <!-- <el-form-item label="记录轨迹">
          <el-switch
            v-model="formInline.extendGjFlag"
            active-value="1"
            inactive-value="0"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item> -->
        <!-- <el-form-item label="轨迹记录间隔">
          <el-input
            style="width: 356px;"
            v-model="formInline.extendLongitude"
            placeholder="轨迹记录间隔"
          >
            <template slot="append">分钟</template>
          </el-input>
        </el-form-item> -->
        <el-form-item label="打卡地点经度">
          <el-input
            style="width: 356px;"
            v-model="formInline.extendLongitude"
            placeholder="打卡地点经度"
          >
            <template slot="append">°E</template>
          </el-input>
        </el-form-item>
        <el-form-item label="打卡地点纬度">
          <div style="display:flex;">
            <el-input
              style="width: 356px;"
              v-model="formInline.extendLatitude"
              placeholder="打卡地点纬度"
            >
              <template slot="append">°N</template>
            </el-input>
            <el-button
              @click="mapVisible = true"
              type="text"
              style="margin-left: 16px;"
              >地图定位</el-button
            >
          </div>
        </el-form-item>
        <el-form-item label="打卡范围要求">
          <el-input
            style="width: 356px;"
            v-model="formInline.extendRangeMetre"
            placeholder="打卡范围要求"
            type="number"
          >
            <span slot="append">米</span>
          </el-input>
        </el-form-item>
        <el-form-item label="打卡图片必填">
          <el-switch
            v-model="formInline.extendPicFlag"
            active-value="1"
            inactive-value="0"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="打卡说明必填">
          <el-switch
            v-model="formInline.extendDescribeFlag"
            active-value="1"
            inactive-value="0"
            active-color="#0495FF"
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="editRuleFun">确 定</el-button>
    </span>
    <mapSearch
      @cancel="mapVisible = false"
      @map-confirm="confirmLocation"
      :visible="mapVisible"
    ></mapSearch>
  </el-dialog>
</template>
<script>
import { mangerEdit } from "@/api/onDutyAndStandBy.js";
import mapSearch from "@/components/map-search/index.vue";
import moment from "moment";
export default {
  components: { mapSearch },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },

    curItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      title: "事项初始规则管理",
      mapVisible: false,
      dksj: 1,
      formInline: {
        extendClient: null,
        sxmc: null,
        state: "是",
        extendCardCount: "1",
        extendGjFlag: "1",
        extendLongitude: "",
        extendLatitude: "",
        extendRangeMetre: "",
        extendPicFlag: "1",
        extendDescribeFlag: "1",
        extendTimeRangeList: [{ time1: "", time2: "" }],
        extendAddress: ""
      }
    };
  },
  mounted() {
    this.formInline = JSON.parse(JSON.stringify(this.curItem));
    if (this.formInline.extendCardCount) {
      this.formInline.extendCardCount = this.formInline.extendCardCount + "";
    }
    if (
      this.curItem.extendTimeRangeList &&
      this.curItem.extendTimeRangeList != "null" &&
      this.curItem.extendTimeRangeList.length
    ) {
      this.dksj = 1;
      this.formInline.extendTimeRangeList = [];
      let times = this.curItem.extendTimeRangeList.split(",");
      times.forEach(element => {
        this.formInline.extendTimeRangeList.push({
          time1: element.split("-")[0],
          time2: element.split("-")[1]
        });
      });
    } else {
      this.dksj = 2;
      this.formInline.extendTimeRangeList = [{ time1: "", time2: "" }];
    }
  },
  methods: {
    pushFixedTimes() {
      this.formInline.extendTimeRangeList.push({
        time1: "",
        time2: ""
      });
    },
    minusFixedTimes(index) {
      this.formInline.extendTimeRangeList.splice(index, 1);
    },
    handleClose() {
      // 关闭弹窗，触发父组件修改visible值
      this.$emit("update:dialogVisible", false);
    },
    confirmLocation(e) {
      this.lnglat = e;
      this.formInline.extendLongitude = e.lng;
      this.formInline.extendLatitude = e.lat;
      this.formInline.extendAddress = e.addr;
      this.mapVisible = false;
    },

    async editRuleFun() {
      let params = {
        ...this.formInline,
        id: this.curItem.id,
        ghEventTypeId: "id_zhishou"
      };
      if (this.dksj == "1" && this.formInline.extendTimeRangeList.length) {
        let times = [];
        this.formInline.extendTimeRangeList.forEach(item => {
          times.push(item.time1 + "-" + item.time2);
        });
        params.extendTimeRangeList = times.toString();
      } else {
        params.extendTimeRangeList = "";
      }

      const res = await mangerEdit(params);

      if (res.data.code == 200) {
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.handleClose();
        this.$emit("refreshList");
      } else {
        this.$message({
          type: "error",
          message: res.data.msg
        });
      }
    }
  },
  computed: {},
  watch: {}
};
</script>

<style scoped lang="less">
/deep/.el-dialog__header {
  border: none;
  height: 64px;
  padding: 24px 16px 16px 24px;
  background: none;

  .el-dialog__title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 20px;
    color: #494c4f;
  }
}

/deep/.el-dialog__body {
  padding: 24px;
}

/deep/.el-input {
  width: 340px !important;
}

/deep/.el-input-number .el-input {
  width: 180px !important;
}
/deep/.el-radio input[aria-hidden="true"] {
  display: none !important;
}

/deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
  .el-radio__inner {
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/standBy/components/ruleSettingDialog.vue